import {FC} from "react";
import {Card} from "../../../../../shared/card/card.style";
import {CardContent, Link, Typography} from "@mui/material";
import {Box} from "@mui/system";
import {usePatientConnect365} from "../../../../../../hooks/use-patient-connect-365/use-patient-connect365";
import {
  EnrollmentStatus
} from "../../../../../layout/slideout/patient-profile-widget/views/patient-connect-365/enrollment-status";
import {
  EnrollmentLink
} from "../../../../../layout/slideout/patient-profile-widget/views/patient-connect-365/enrollment-link";
import {PatientConnectCardTitle} from "../../../../../layout/slideout/patient-profile-widget/views/patient-connect-365/patient-connect-card-title";
import {
  PatientConnectLogo
} from "../../../../../layout/slideout/patient-profile-widget/views/patient-connect-365/PatientConnectLogo";

export const PatientConnect365: FC = () => {
  const {
    pc365Enrollment,
    handleInviteClick,
    isPending,
    showEnrollmentStatus,
    showEnrollmentLink,
    statusBackgroundColor,
    statusLabel
  } = usePatientConnect365();

  const inviteLinkColor = pc365Enrollment.isReadyToSendEnrollment ? 'primary.main' : 'gray[500]';

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <PatientConnectLogo />
            <Box>
              <PatientConnectCardTitle />
            </Box>
          </Box>
          <EnrollmentStatus
            statusLabel={statusLabel}
            statusBackgroundColor={statusBackgroundColor}
            showEnrollmentStatus={showEnrollmentStatus} />
        </Box>
        <EnrollmentLink
          handleInviteClick={handleInviteClick}
          inviteLinkColor={inviteLinkColor}
          isPending={isPending}
          showEnrollmentLink={showEnrollmentLink} />
      </CardContent>
    </Card>
  );
}
